"use client";

import { Box } from "@chakra-ui/react";
import { usePathname } from "next/navigation";
import { KoFiButton } from "@/components/ux/KoFiButton";

export function KoFiSection() {
  const pathname = usePathname();

  if (pathname === "/SignIn" || pathname.startsWith("/SignUp")) {
    return null;
  }

  return (
    <Box
      as="section"
      px={{ base: 4, md: 6, lg: 8 }}
      py={{ base: 5, md: 6 }}
      display="flex"
      justifyContent="center"
      w="full"
      position="relative"
      zIndex={20}
    >
      <KoFiButton />
    </Box>
  );
}
